import { Department } from '@interfaces/Department';

export class DepartmentPickerItem {
  public id: string;
  public code: string;
  public description: string;
  public description2: string;
  public isActive: boolean;
  public company: string;
  /**
   *
   */
  public constructor(d: Department) {
    this.id = d.id;
    this.code = d.code;
    this.description = d.description;
    this.description2 = d.description2;
    this.isActive = d.isActive;
    this.company = d.company;
  }
}
